<!--<div>
  <button (click)="setMapView()">Set Map</button>
</div>-->
<div id="s-to-top"></div>

<div class="map-btn" [ngClass]="{'lv-map-btn': showMapView}">
  <button (click)="toggleView()" class="flex-container ion-align-items-center" tapEffect>
    @if (showMapView) {
      <div class="btn lv">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
             class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
        </svg>
        <span>List View</span>
      </div>
    }
    @if (!showMapView) {
      <div class="btn mv">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
             class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/>
        </svg>
        <span>Map View</span>
      </div>
    }
    <!--{{ showMapView ? 'Show List View' : 'Show Map View' }}-->
  </button>
</div>

@if (showMapView || mapLoaded) {
  <div class="map-w" [ngClass]="{ 'd-none': !showMapView }">
    <!--<div class="search-bar">
      <div class="sc-inr-wrap">
        <div class="search-icon">
          <img [ngSrc]="environment?.imgHost +  '/new-assets/india/new-app/icons/filter-search-icon.webp?format=png'"
               alt="filter-search-icon" width="100" height="100">
        </div>
        <input type="search" placeholder="Search in Mumbai" class="ip-box">
        <div>
          <div class="near-loc-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                 id="near-me" fill="none">
              <path d="M0 0h24v24H0V0z"></path>
              <path fill="#1b569c"
                    d="M18.75 3.94L4.07 10.08c-.83.35-.81 1.53.02 1.85L9.43 14c.26.1.47.31.57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>-->


    <app-b2b-ola-map
      [mapConfig]="mapConfig"
      [containerName]="'m-blp-omap'"
      [center]="{ lat: compData?.container?.lat, lng: compData?.container?.lng }"
      [zoom]="10"
      (centerChangedEvent)="onMapCenterChanged($event)"
    ></app-b2b-ola-map>

    <div class="map-csl">

      @if (showMapLoader) {
        <!-- TODO show loader -->
        <div class="ldProperty">
          <div class="flex-container ion-align-items-center loadBox">
            <span class="loader"></span> Loading
          </div>
        </div>
      }
      <div class="mapPtyList" #appScrollSpyDirective appScrollSpy (activeChild)="onActiveProperty($event)">
        <ng-container *ngTemplateOutlet="mapPropertiesTemplate;"></ng-container>
      </div>
    </div>

  </div>
}


@for (container of otherRawContainers; track trackByFn(index, container); let index = $index) {
  <div>
    @switch (container?.component) {
      @case ('InformationCardComponent') {
        <div class="info-card">
          <app-b2b-information-card
            [compData]="{
              container: container
            }">
          </app-b2b-information-card>
        </div>
      }
      @default {
        @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
          <ng-container *ngComponentOutlet="component; inputs: {
            compData: {
              container: container
            }
          }"/>
        }
      }
    }
  </div>
}

<ng-template #mapPropertiesTemplate>
  @for (mapProperty of mapProperties; track mapProperty?.uid; let index = $index; ) {
    <div class="map-pty" [id]="'mv-'+mapProperty?.uid"
         [ngClass]="{'s-map-prop': selectedMapProperty?.uid === mapProperty?.uid }">
      <lib-feature-list-item
        [compData]="{
              container: mapProperty,
              index: index,
              queryParams: queryParams
            }"
        [enableMapView]="true"
        (selectedPropertyEvent)="onSelectMapProperty(mapProperty)"
      >
      </lib-feature-list-item>
    </div>
  }


</ng-template>

<div #infiniteContainer class="infinite-container">
  <div class="room-detail-mob">
    <div [ngClass]="{
         'h-cards': showGridView
       }">
      <!-- Dynamic feature list starts -->
      @for (container of ($finalContainerItems | async); track trackByFn(index, container); let index = $index; let even = $even; ) {
        <div class="list-item-min-height card-lst child-1" [ngClass]="{
          'hs-min': container?.feature?.type === F_TYPES.SHORTSTAY,
          'es-min': container?.feature?.type === F_TYPES.EXTENDEDSTAY,
          'ssp-min': container?.feature?.type === F_TYPES.SHORTSTAY_PACKAGE
        }">
          @if (isServer || isSeoPage) {
            <lib-feature-list-item
              [compData]="{
              container: container,
              index: index,
              promotionData: promotionData,
              queryParams: queryParams
            }">
            </lib-feature-list-item>
          } @else {
            @defer (on viewport) {
              <lib-feature-list-item
                [compData]="{
              container: container,
              index: index,
              promotionData: promotionData,
              queryParams: queryParams
            }">
              </lib-feature-list-item>
            } @placeholder (minimum 500ms) {
              <!-- TODO placeholder -->
              <div>
                <!--some placeholder-->
                <ng-container *ngTemplateOutlet="skeletonTemp"></ng-container>
              </div>
            }
          }
        </div>

        @if (promotionData?.widgets?.length > 0) {
          <!--@let loadWidgetAfter =
            promotionData?.loadWidgetAfter > 0
              ? promotionData?.loadWidgetAfter
              : 4;-->
            <!--          @let loadWidgetAfter = 4;-->
          @if (index > 0 && (index + 1) % loadDynamicPromosAfter === 0) {
            @let widgetIndex = ((index + 1) / loadDynamicPromosAfter) - 1;
            @if (promotionData?.widgets?.[widgetIndex]; as selectedWidget) {
              @if (!selectedWidget?.loadedOnClient || (selectedWidget?.loadedOnClient && selectedWidget?.isPromotionContainersAvailable)) {

                @let minHeight = isDesktop ? selectedWidget?.desktopConfig?.height : selectedWidget?.mobileConfig?.height;

                <div class="child-2" [ngStyle]="{ 'min-height': minHeight }">
                  @defer (on viewport) {
                    <app-item-dyn-promos
                      [compData]="{
                      promotionData: promotionData,
                      queryParams: queryParams
                    }"
                      [selectedWidget]="selectedWidget"
                    >

                    </app-item-dyn-promos>
                  } @placeholder (minimum 500ms) {
                    <!-- TODO loader -->
                    <div>
                      <ng-container *ngTemplateOutlet="skeletonTemp; context:{
                          minHeight:minHeight,
                          }"></ng-container>
                    </div>
                  }
                </div>
              }
            }
          }
        }

        @if (container?.promotionalContainers?.length > 0 && index > 0 && (index - 1) % loadStaticPromosAfter === 0) {
          <div class="child-3">
            @defer (on viewport) {
              <app-item-promos
                [compData]="{
              container: container,
              index: index,
              promotionData: promotionData,
              queryParams: queryParams
            }"
              >
              </app-item-promos>
            } @placeholder (minimum 500ms) {
              <!-- TODO loader -->
              <div>
                <ng-container *ngTemplateOutlet="skeletonTemp;"></ng-container>
              </div>
            }
          </div>
        }
      }

      <!-- Show error when no more locality properties is available -->
      @if (errorCodes?.indexOf('locality_properties_not_found') > -1 && localitiesErrorContainers?.length > 0) {
        <div class="locErrorCard">
          <!-- Show localities error -->
          @if ((('LocalityPropertiesNotFoundComponent' | b2bDynamicLoaderPipe) | async); as component) {
            <ng-container *ngComponentOutlet="component;
              inputs: {
                compData: {
                    container:  localitiesErrorContainers[0]
                }
              }"
            />
          }
        </div>
      }

      <!-- Dynamic other feature list starts -->
      @for (container of ($otherPropertiesContainerItems | async); track trackByFn(index, container); let index = $index) {
        <div class="list-item-min-height">
          <!-- Testing code 1 starts -->
          @defer (on viewport) {
            <lib-feature-list-item
              [compData]="{
              container: container,
              queryParams: queryParams
            }">
            </lib-feature-list-item>
          } @placeholder (minimum 500ms) {
            <!-- TODO placeholder -->
            <div>
              <!--some new placeholder-->
              <ng-container *ngTemplateOutlet="skeletonTemp"></ng-container>
            </div>
          }
          <!-- Testing code 1 ends -->
        </div>
      }

    </div>


    @if (errorCodes?.indexOf('properties_not_found') > -1 && finalErrorContainers?.length > 0) {
      <!-- Show final error message when properties not found -->
      <div class="noPtyCard">
        @if ((('PropertiesNotFoundComponent' | b2bDynamicLoaderPipe) | async); as component) {
          <ng-container *ngComponentOutlet="component; inputs: {
          compData: {
            container:  finalErrorContainers[0]
          }
        }"/>
        }
      </div>
    }

    <!--load more button-->
    @if (errorCodes?.indexOf('properties_not_found') === -1 && !finalErrorContainers?.length && showLoadMoreButton) {
      <div class="flex-container ion-align-items-center ion-justify-content-center ld-btn">
        <button (click)="fireLoadMoreDataEvent($event)">Load More Properties</button>
      </div>
    }

    <!-- Dynamic feature list ends -->
    @if (showInfiniteScroll && errorCodes?.indexOf('properties_not_found') === -1 && !finalErrorContainers?.length) {
      <div class="scroll-box" scrollEnd (scrolled)="fireLoadMoreDataEvent($event)"
           [rootMargin]="'0px 0px 0px 0px'"
           [threshold]="[0]">
      </div>
    }

    @if (showLoader$ | async) {
      <div>
        <div class="loading box-1"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
        <div class="loading box"></div>
      </div>
    }
  </div>
</div>


<ng-template #skeletonTemp let-minHeight="minHeight">
  <div class="box loading" [ngStyle]="{ 'height': minHeight }"></div>
</ng-template>
